import { render, staticRenderFns } from "./NewBannerSlider.vue?vue&type=template&id=0dc6a5a6&"
import script from "./NewBannerSlider.vue?vue&type=script&lang=js&"
export * from "./NewBannerSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports